import { toast } from 'react-toastify';
import appApi from '../../../../../../api/app-api';
import { displayErrorText } from '../../../../../../api/errors/api-error-codes';

export const deleteDepositPaymentOperation = async (
  depositId: number,
  depositPaymentId: number,
  setLoading: (loading: boolean) => void,
  onSuccess: () => void,
) => {
  if (!depositId || depositId <= 0) {
    toast.warn('מזהה הפקדה לא תקין');
    return;
  }

  if (!depositPaymentId || depositPaymentId <= 0) {
    toast.warn('מזהה תשלום לא תקין');
    return;
  }

  try {
    setLoading(true);

    const res = await appApi.deleteAccountingDepositPayment(
      depositId,
      depositPaymentId,
    );

    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setLoading(false);
      return;
    }

    toast.success('התשלום הוסר מההפקדה בהצלחה');
    setLoading(false);
    onSuccess();
  } catch (e) {
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
    setLoading(false);
  }
};
